import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import { viaEmailChatBotOrOtherOptionsArray, b2bOrB2cOptionsArray } from './SharedConstants';

const genderOptionsArray = [
  { value: 'Any', label: 'Any' },
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'NonBinary', label: 'Non-Binary' },
  { value: 'Other', label: 'Other' },
];

const onlineWebPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'InteractionRequired',
        label: 'Is interaction required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ViaEmailChatBotOrOther',
        label: 'Via email chat bot or other?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: viaEmailChatBotOrOtherOptionsArray,
      },
      {
        fieldName: 'ProductOrServiceInquiry',
        label: 'Product or Service Inquiry?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'B2borB2c',
        label: 'B2B or B2C?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: b2bOrB2cOptionsArray,
      },
    ],
  },
  {
    label: 'B2B Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'FictiosWebsiteCreationNeeded',
        label: 'Fictious Website Creation needed',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IsBusinessInformationRequired',
        label: 'Is Business Information required',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BusinessInformationDescription',
        label: 'If Yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'B2C Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'OtherQualifications',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Questionnaire',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TranslationProvided',
        label: 'Translation of Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Shop Validation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'NumScreenshotsRequired',
        label: 'Number of Screen Shots Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'OtherPhotosDesc',
        label: 'Describe other Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Purchase',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineWeb,
    fields: [
      {
        fieldName: 'PurchaseReqd',
        label: 'Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ReceiptReqd',
        label: 'Receipt Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseAmtCurId',
        label: 'Purchase Amount Currency',
        className: 'col-12',
        type: InputTypesEnum.ActiveCurrencySelect,
      },
      {
        fieldName: 'PurchaseAmt',
        label: 'Minimum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxPurchaseAmt',
        label: 'Maximum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PurchaseDesc',
        label: 'Item Required to Be Purchased',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'PurchaseReimbursed',
        label: 'Purchase Reimbursed by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseReturned',
        label: 'Required Purchase to be returned by Evaluator as part of their Assignment Scenario?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
];

export default onlineWebPages;
